import React, { FC, ReactNode } from 'react'
import './icon.scss'

export const BusinessDuoHighlighterIcon: FC<ReactNode> = () => {
  return (
    <div className='icon-container'>
      <img
        srcSet={
          'https://www.static-immobilienscout24.de/statpic/statpic/sales-journey/hos/rle-wizard/icons/45d7909cf7c8fad51c4a814306ab81ca_BusinessDuo_highlighter.png'
        }
        src={
          'https://www.static-immobilienscout24.de/statpic/statpic/sales-journey/hos/rle-wizard/icons/45d7909cf7c8fad51c4a814306ab81ca_BusinessDuo_highlighter.png'
        }
        width={128}
        height={128}
        alt={''}
      />
    </div>
  )
}
